import { render, staticRenderFns } from "./ContractViewTimelineItemCreated.vue?vue&type=template&id=f841a7ec&"
import script from "./ContractViewTimelineItemCreated.vue?vue&type=script&lang=js&"
export * from "./ContractViewTimelineItemCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
  VTimelineItem,
})
